import fetch from 'utils/fetch';
import { createAction } from 'redux-actions';

export const requestFormAction = createAction('REQUEST_FORM');
export const receiveFormAction = createAction('RECEIVE_FORM');
export const caseNameUpdateAction = createAction('FORM_CASE_NAME_UPDATE');
export const updatePlanningDateAction = createAction('UPDATE_PLANNING_DATE');
export const updatePlanningTimeAction = createAction('UPDATE_PLANNING_TIME');
export const updatePreplanningDateAction = createAction(
  'UPDATE_PREPLANNING_DATE'
);
export const updateDurationAction = createAction('UPDATE_DURATION');
export const updateDurationUnitAction = createAction('UPDATE_DURATION_UNIT');
export const updateWorkerIdAction = createAction('UPDATE_WORKER_ID');
export const updateSecondaryWorkerIdsAction = createAction(
  'UPDATE_SECONDARY_WORKER_IDS'
);

import moment from 'moment';
import { DATE_FORMAT } from 'common/components/PreplanificationSelection';

function fetchForm(id) {
  return dispatch => {
    dispatch(requestFormAction());
    fetch(`/pco-manager/aast/cases-creation/${id}/step2.json`)
      .then(r => r.json())
      .then(nodes => {
        dispatch(receiveFormAction(nodes));
      });
  };
}

function shouldFetchForm(id, state) {
  const form = state.form;

  if (form.id === undefined && id > 0 && !form.isFetching) {
    return true;
  }

  return false;
}

export const fetchFormIfNeeded = id => (dispatch, getState) => {
  const state = getState();
  if (shouldFetchForm(id, state)) {
    dispatch(fetchForm(id));
  }
};

export const updatePlanningDate = date => (dispatch, getState) => {
  if (date) {
    console.log(`updated date ${date.date}`);
    dispatch(updatePlanningDateAction(moment(date.date).format(DATE_FORMAT)));
  } else {
    dispatch(updatePlanningDateAction(date));
  }
};

export const updatePlanningTime = time => (dispatch, getState) => {
  dispatch(updatePlanningTimeAction(time));
};

export const updatePreplanningDate = date => (dispatch, getState) => {
  dispatch(updatePreplanningDateAction(date));
};

export const updateDuration = duration => (dispatch, getState) => {
  dispatch(updateDurationAction(duration));
};

export const updateDurationUnit = unit => (dispatch, getState) => {
  dispatch(updateDurationUnitAction(unit));
};

export const updateWorkerId = id => (dispatch, getState) => {
  dispatch(updateWorkerIdAction(id));
};

export const updateSecondaryWorkerIds = ids => (dispatch, getState) => {
  dispatch(updateSecondaryWorkerIdsAction(ids));
};



// WEBPACK FOOTER //
// ./src/modules/saas/aast/cases-creation/step2/actions/form.js